import { urlFor } from '@lib/sanity'
import { getDate } from '@utils/formatDate'
import Image from 'next/image'
import Link from 'next/link'

import styles from './NewsletterCard.module.scss'

export default function NewsletterCard({ data, ...props }) {
  // console.log('NEWSLETTER: ', data)

  const { title, slug, excerpt, thumbnail, date } = data

  let d = getDate(date, 'long')

  return (
    <div className={styles.wrapper}>
      {props?.noImage ? null : (
        <div className={styles.imageContainer}>
          <div className={styles.image}>
            <Link href={slug} title={title} prefetch={false} target="_blank">
              <Image
                src={urlFor(thumbnail.asset)
                  .crop('focalpoint')
                  .fit('crop')
                  .width(300)
                  .height(175)
                  .quality(90)
                  .dpr(1)
                  .sharpen(12)
                  .format('webp')
                  .url()}
                fill
                alt={title}
                className="object-cover object-center"
              />
            </Link>
          </div>
        </div>
      )}
      <div className={styles.textContainer}>
        <Link href={slug} title={title} prefetch={false} target="_blank">
          <h3
            className={
              props.noImage ? 'text-[22px]' : 'text-[22px] sm:text-[28px]'
            }
          >
            {title}
          </h3>
        </Link>
        <p className={styles.date}>{d}</p>

        <div className={styles.excerpt}>
          {props?.noExcerpt ? null : <p>{excerpt}</p>}
        </div>
      </div>
    </div>
  )
}
